import session from '../../auth_api/session'
// import Vue from 'vue'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'kindergarten/api/'
const appName = 'kindergarten'

export default {
  namespaced: true,
  state: {
    logOperationFile: [],
    childrenGardenFiles: { 'results': [] },
    childrenGardenFile: {},
    defaultChildrenGardenFile: {
      id: null,
      create_date: null,
      time_stamp: null,
      supplier: null,
      ogrn: '',
      file_path: null,
      filename: '',
      processing_type: {},
      process_status: {},
      type_reestr: {}
    },
    tableSearch: { period: '', search: '' },
    tab: 'tab-1'
  },
  mutations: {
    setLogOperationFile (state, payload) {
      state.logOperationFile = payload
    },
    setChildrenGardenFiles (state, payload) {
      state.childrenGardenFiles = payload
    },
    setChildrenGardenFile (state, payload) {
      state.childrenGardenFile = payload
    },
    setDefaultChildrenGardenFile (state) {
      state.childrenGardenFile = Object.assign({}, state.defaultChildrenGardenFile)
    },
    setTab (state, payload) {
      state.tab = payload
    }
  },
  actions: {
    fetchLogOperationFile ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = appName + '-fetchLogOperationFile'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'log-operation-file/'
        let params = {}
        params['file_id'] = payload.file_id
        session.get(_url, { params: params })
          .then(response => {
            commit('setLogOperationFile', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchChildrenGardenFiles ({ commit, dispatch, getters }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = appName + '-fetchChildrenGardenFiles'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = { type_abbr: payload.typeAbbr }
        // let params = {}
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        const tableSearch = getters.tableSearch
        Object.keys(tableSearch).forEach((key) => {
          params[key] = tableSearch[key]
        })
        let _url = appURL + 'children-garden-file/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setChildrenGardenFiles', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchChildrenGardenFile ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = appName + '-fetchChildrenGardenFile'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'children-garden-file/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setChildrenGardenFile', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertFile ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = appName + '-insertFile-' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })

        const data = new FormData()
        if (payload.file_path !== null && typeof payload.file_path === 'object') {
          data.append('file_path', payload.file_path)
        }

        let _url, method
        if (payload.id === null) {
          _url = appURL + 'children-garden-file/'
          method = 'post'
        } else {
          _url = appURL + 'children-garden-file/' + payload.id + '/'
          method = 'patch'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setChildrenGardenFile', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    logOperationFile (state) {
      return state.logOperationFile
    },
    childrenGardenFiles (state) {
      return state.childrenGardenFiles
    },
    childrenGardenFile (state) {
      return state.childrenGardenFile
    },
    tableSearch (state) {
      return state.tableSearch
    },
    tab (state) {
      return state.tab
    }
  }
}
